import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileBlobService {
  private fileBlob: Blob | null = null;
  private fileNAme: string; 
  private fileTaxId: string;

  constructor() { }

  setFileBlob(blob: Blob, fileNAme: string, fileTaxId: string ) {
    this.fileBlob = blob;
    this.fileNAme = fileNAme;
    this.fileTaxId = fileTaxId;
  }

  getFileBlob(): Blob | null {
    return this.fileBlob;
  }
  getfileName() {
    return this.fileNAme;
  }

  getFileTaxId() {
    return this.fileTaxId;
  }


}
